module.exports = __webpack_public_path__ + "img/lake002.44951cbe.jpg";